import { render, staticRenderFns } from "./PrintTransfer.vue?vue&type=template&id=37354df8&scoped=true"
import script from "./PrintTransfer.vue?vue&type=script&lang=js"
export * from "./PrintTransfer.vue?vue&type=script&lang=js"
import style0 from "./PrintTransfer.vue?vue&type=style&index=0&id=37354df8&prod&scoped=true&lang=css"
import style1 from "./PrintTransfer.vue?vue&type=style&index=1&id=37354df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37354df8",
  null
  
)

export default component.exports